import { lang } from '@lib/constants'

export const lastUrlSegment = (string: string | undefined) =>
	string ? string.substring(string.lastIndexOf('/') + 1) : null

// A11Y: Remove empty headings from HTML content (e.g., from Shopify/CMS)
// Empty headings fail WCAG - screen readers announce them but there's no content
export const removeEmptyHeadings = (html: string): string => {
	if (!html) return ''
	// Remove h1-h6 tags that contain only whitespace, <br>, or &nbsp;
	return html.replace(/<h([1-6])[^>]*>(\s|<br\s*\/?>|&nbsp;)*<\/h\1>/gi, '')
}

export const splitUrl = (url: string): string | null => {
	const relativeUrl =
		lang === 'es-es'
			? `/categorias${url.split('myshopify.com/collections', 2)[1]}`
			: url.split('myshopify.com', 2)[1]

	if (relativeUrl.includes('undefined')) {
		return null
	}

	return relativeUrl
}
